function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6001 8.40039L19.6001 15.4004",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40005 25.2004C4.95686 23.2898 2.80005 19.6172 2.80005 15.4004H25.2C25.2 19.6172 23.0432 23.2898 19.6 25.2004",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.40015,
  y: 25.2002,
  width: 11.2,
  height: 1.4,
  stroke: "#151515",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.1002 5.6001L9.8502 6.6001C10.6502 7.66676 10.6502 9.13343 9.8502 10.2001L9.1002 11.2001",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3001 4.2002L14.0501 5.20019C14.8501 6.26686 14.8501 7.73353 14.0501 8.8002L13.3001 9.8002",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5001 5.6001L18.2501 6.6001C19.0501 7.66677 19.0501 9.13343 18.2501 10.2001L17.5001 11.2001",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgSoup = function SvgSoup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/soup.6a12a207.svg";
export { ForwardRef as ReactComponent };